import React, { useCallback, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { useAuth0 } from "@auth0/auth0-react";
import TakaOverviewTable from "components/supplyAndDemand/overviewTable";
import CustomTabPanel from "components/supplyAndDemand/Tabs/customTabPanel";
import ParametricAnalysis from "pages/parametricAnalysis";
import { useParams } from "react-router";
import HelvetiaCompliancyCheck from "pages/helvetiaCompliancyCheck";
import OldHelvetiaOverView from "components/oldHelvetia/overView";
import { supplyAndDemandGetProductById } from "pages/supplyDemand/supplyDemand.service";
import { getToken } from "utils/loadAuth";
import Notification from "components/snackbar";
import constants from "../../../constants/constants.json";

export default function SupplyAndDemandPageTabs({ isNavbarOpen }) {
  const { getAccessTokenSilently, loginWithRedirect } = useAuth0();
  let { fid } = useParams();
  const [product, setProduct] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const [openAlert, setOpenAlert] = useState(false);
  const [alertData, setAlertData] = useState({
    message: "",
    severity: "",
  });
  const { message, severity } = alertData;

  let { pid } = useParams();

  const getProductById = useCallback(async () => {
    try {
      const token = await getToken({
        getAccessTokenSilently,
        loginWithRedirect,
      });
      if (token) {
        const response = await supplyAndDemandGetProductById({
          productId: pid,
          token,
        });
        const data = response?.data;
        if (data) {
          setProduct(data.items[0]);
        }
      }
    } catch (error) {
      setOpenAlert(true);
      setAlertData({
        ...alertData,
        message: constants.requestFailed + error.status,
        severity: "error",
      });
      console.log("Error: ", error.message);
    }
  }, [pid, setProduct, getAccessTokenSilently, loginWithRedirect, alertData]);

  useEffect(() => {
    if (!pid) return;
    setIsLoading(true);
    getProductById();
    setIsLoading(false);
  }, [pid, getProductById]);

  if (!product?.product_name) {
    return null;
  }

  return (
    <Box sx={{ width: "100%" }} data-testid={"supply-and-demand-tabs"}>
      <CustomTabPanel value={Number(fid)} index={1} isNavbarOpen={isNavbarOpen}>
        {!isLoading && Object.keys(product).length !== 0 && (
          <Box>
            <TakaOverviewTable product={product} />
          </Box>
        )}
      </CustomTabPanel>
      <CustomTabPanel isNavbarOpen={isNavbarOpen} value={Number(fid)} index={2}>
        <ParametricAnalysis
          productId={pid}
          isNavbarOpen={isNavbarOpen}
          product={product}
        />
      </CustomTabPanel>
      <CustomTabPanel isNavbarOpen={isNavbarOpen} value={Number(fid)} index={5}>
        {product?.product_name === "V93K" ? (
          <HelvetiaCompliancyCheck
            productId={pid}
            isNavbarOpen={isNavbarOpen}
          />
        ) : (
          <OldHelvetiaOverView
            productName={product?.product_name}
            isNavbarOpen={isNavbarOpen}
            disableVirtualization={false}
          />
        )}
      </CustomTabPanel>
      <Notification
        message={message}
        open={openAlert}
        setOpen={setOpenAlert}
        severity={severity}
      />
    </Box>
  );
}
